import BrownieImage from '../assets/brownie.jpeg';

const HeroSection = ({ domainStatus, contactEmail }) => {
  return (
    <section className="hero-section">
      <div className="hero-content">
        <h1 className="hero-title">{domainStatus}</h1>
        <p className="hero-subtitle">
          Uma oportunidade deliciosa para o seu novo negócio de brownies.
          <br />
          Para informações sobre a aquisição do domínio, entre em contato.
        </p>

        <a
          href={`mailto:${contactEmail}`}
          className="cta-button"
        >
          {`Fale Conosco: ${contactEmail}`}
        </a>

        <p className="contact-info">
          Entre em contato por e-mail para mais detalhes.
        </p>
      </div>

      <div className="hero-image-container">
        <img src={BrownieImage} alt="Brownie apetitoso" className="brownie-img" />
      </div>
    </section>
  );
};

export default HeroSection;